import {Truncate} from '@dropbox/dig-components/truncate';
import {Text} from '@dropbox/dig-components/typography';
import {atoms, Box, Split, withShade} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {Avatar} from 'components/DSYS/Avatar';
import {ROUTE_PATHS} from 'constant';
import {TileRowLink} from 'views/home/dashboard/TileRowLink';

const profileHref = (ldap: string): string =>
  ldap ? ROUTE_PATHS.PROFILE.replace(':userid', ldap) : ROUTE_PATHS.PEOPLE;

export const CalendarPersonRow = ({
  name,
  ldap,
  photoUrl,
  // relation,
  icon,
  label,
}: {
  name: string;
  ldap: string;
  photoUrl?: string | null;
  relation?: string | null;
  icon?: React.ComponentType<React.SVGAttributes<SVGElement>>;
  label: string;
}) => {
  const shade = withShade({style: {marginInline: -8, cursor: 'pointer'}});
  return (
    <TileRowLink to={profileHref(ldap)}>
      <Box
        className={shade.className}
        style={shade.style}
        paddingX="8"
        paddingY="4"
        borderRadius="Medium"
      >
        <Split alignY="center" gap="8">
          <Split.Item>
            <Avatar size="small" user={{name, ldap, profile_photo_url: photoUrl} as never} />
          </Split.Item>
          <Split.Item width="fill">
            <Text tagName="div" style={{minWidth: 0}}>
              <Truncate observeParent>{name}</Truncate>
            </Text>
            {/* {relation ? (
              <Text size="small" color="faint" tagName="div" style={{minWidth: 0}}>
                <Truncate observeParent>{relation}</Truncate>
              </Text>
            ) : null} */}
          </Split.Item>
          <Split.Item>
            <Box display="flex" alignItems="center" style={{gap: 4}}>
              <Text size="small" color="faint">
                {label}
              </Text>
              {icon ? (
                <UIIcon src={icon} size="small" className={atoms({color: 'Text Subtle'})} />
              ) : null}
            </Box>
          </Split.Item>
        </Split>
      </Box>
    </TileRowLink>
  );
};
